export default function sizeToTxt(size: number) {
  const fileSizeList = ["B", "kB", "MB", "GB", "TB"];
  let i = size <= 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  i = i > fileSizeList.length - 1 ? fileSizeList.length - 1 : i;
  return (size / Math.pow(1024, i)).toFixed(2) + " " + fileSizeList[i];
}

export function obfuscateImageName(imageName: string): string {
    let hash = 0;
    for (let i = 0; i < imageName.length; i++) {
        const char = imageName.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash |= 0; // Convert to 32bit integer
    }
    return `img_${Math.abs(hash).toString(36)}`;
}
